import React from 'react'
import Pagination from '../Pagination/pagination'

const Client = ({ data, exportData, page, PER_PAGE, count, setPage }) => {
    return (
        <>
            <div className="d-flex justify-content-between">
                <p>Total Client : {data?.clientData?.totalCount}</p>
                <button className='btn btn-primary' onClick={() => exportData('CLIENT')}>Export</button>
            </div>
            <table className="table  shadow mt-3">
                <thead className="table-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Mobile Number</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !data?.clientData?.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                            :
                            <>
                                {
                                    data?.clientData?.data?.map((item, index) => {
                                        return <>
                                            <tr key={index}>
                                                <th style={{ padding: '0.4rem .5rem' }} scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.name}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.email}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.mobileNo}</td>
                                            </tr>
                                        </>
                                    })
                                }
                            </>
                    }
                </tbody>
            </table>
            <div className='w-100 d-flex justify-content-center'>
                <div className='pagination_Position'>
                    {count > 10 &&
                        <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                    }
                </div>
            </div>
        </>
    )
}

export default Client